import { render } from "./FreNchfries.vue?vue&type=template&id=132b436a"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/FreNchfries.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "132b436a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('132b436a', __exports__)) {
    api.reload('132b436a', __exports__)
  }
  
  module.hot.accept("./FreNchfries.vue?vue&type=template&id=132b436a", () => {
    api.rerender('132b436a', render)
  })

}


export default __exports__